import React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ViewUtil, { Icons } from "../../../utils/viewUtility";
import ArrowLeft from "@mui/icons-material/KeyboardBackspace";
import Icon from "../Icon/Icon";
import styles from "./DialogCss";
import clsx from "clsx";
import { withStyles } from "@mui/styles";

const modalDialog = (props) => {
  const { classes } = props;
  return (
    <Dialog
      hideBackdrop={props.hideBackdrop}
      children={props.children}
      onBackdropClick={props.onBackdropClick}
      open={typeof props.open !== "undefined" ? props.open : true}
      PaperProps={props.PaperProps ? props.PaperProps : {}}
      className={
        props.className ? clsx(props.className, classes.root) : classes.root
      }
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={!!props.fullScreen}>
      {props.allowBack || props.title || props.closeable ? (
        <Grid
          container
          className={classes.navGrid}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            className={classes.back}
            style={{
              visibility: props.allowBack ? "visible" : "hidden",
            }}
            xs={1}
          >
            <ArrowLeft
              className={classes.arrowLeft}
              onClick={props.onBackPressed}
            />
          </Grid>

          <Grid
            item
            style={{
              visibility: props.title ? "visible" : "hidden",
            }}
            xs={8}
          >
            {props.title ? (
              <DialogTitle id="alert-dialog-title-1" className={classes.title}>
                {props.title}
              </DialogTitle>
            ) : (
              ""
            )}
          </Grid>

          <Grid
            item
            className={classes.close}
            style={{
              visibility: props.closeable ? "visible" : "hidden",
            }}
            xs={2}
          >
            <Icon
              iconType={Icons.CLOSE_IMAGE}
              className={classes.closeImg}
              onClick={props.onClose}
            />
          </Grid>
        </Grid>
      ) : null}
      <DialogContent
        align={props.align ? props.align : "center"}
        className={props.contentClassName ? props.contentClassName : ""}
        style={props.contentStyle}
      >
        {props.children}
      </DialogContent>
      {props.actionBtn ? (
        <DialogActions justify="center" id={"qwerty"}>
          <Button
            variant={"contained"}
            size="large"
            className={classes.actionBtn}
            color={"primary"}
            onClick={props.handleClose}
          >
            {ViewUtil.OK}
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
export default withStyles(styles)(modalDialog);
